/**
 * Builds a TradingView chart URL for a given exchange, symbol, and contract type.
 *
 * @param {string} exchangeName  - Exchange name as stored in DB (e.g. "Binance", "Bybit")
 * @param {string} symbol        - Symbol as stored in DB (e.g. "BTC" or "BTCUSDT")
 * @param {string} contractType  - "SPOT", "LONG", or "SHORT"
 * @returns {string}             - Full TradingView chart URL
 *
 * Usage:
 *   import { buildTradingViewUrl } from '../utils/tradingViewUrl';
 *   const url = buildTradingViewUrl(pos.name, pos.symbol, pos.contract);
 *   window.open(url, '_blank');
 */
export const buildTradingViewUrl = (exchangeName, symbol, contractType) => {
  // Normalise exchange name: uppercase, strip spaces/special chars
  const tvExchange = (exchangeName || '').toUpperCase().replace(/\s+/g, '');

  // Ensure symbol ends with USDT (TradingView pair format)
  const baseSymbol = (symbol || '').toUpperCase();
  const tvSymbol = baseSymbol.endsWith('USDT') ? baseSymbol : baseSymbol + 'USDT';

  const contract = (contractType || '').toUpperCase();

  // Perpetuals (LONG / SHORT) use the .P suffix on TradingView
  const tvPair = (contract === 'LONG' || contract === 'SHORT')
    ? `${tvSymbol}.P`
    : tvSymbol;

  return `https://www.tradingview.com/chart/?symbol=${tvExchange}:${tvPair}`;
};
